import { useParams } from 'react-router-dom'

import { SignDocumentFlow } from '../components/documents/SignDocumentFlow'
import { useAuth } from '../store/hooks'
import { SceneHeader } from '../components/scene/SceneHeader'

const SignDocumentScreen = () => {
  const { documentId, workspaceId } = useParams()
  const { authUser } = useAuth()

  if (!workspaceId || !documentId || !authUser) {
    return <div>Document not found</div>
  }

  return (
    <div>
      <SceneHeader />
      <main className="p-4">
        <SignDocumentFlow documentId={documentId} workspaceId={workspaceId} />
      </main>
    </div>
  )
}

export default SignDocumentScreen
